export const UsersPurpose = {
    FOR_DRIVERS_LIST: 'FOR_DRIVERS_LIST',
    FOR_ASSIGNED_DRIVER_ASSIGNMENTS: 'FOR_ASSIGNED_DRIVER_ASSIGNMENTS',
    FOR_ARCHIVED_DRIVER_ASSIGNMENTS: 'FOR_ARCHIVED_DRIVER_ASSIGNMENTS',
    FOR_SEARCHED_DRIVER_ASSIGNMENTS: 'FOR_SEARCHED_DRIVER_ASSIGNMENTS',
    FOR_DRIVER_ASSIGNMENT: 'FOR_DRIVER_ASSIGNMENT',
};
